import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { Col, Row, Table } from "reactstrap";
import { convertirFecha } from "utils/generalFunctions";
import Select from "react-select";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import Footer from "components/Footer/Footer";

var ps;

function ListadoInversores(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [inversores, setInversores] = useState([]);
  const [inversoresPintar, setInversoresPintar] = useState([]);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [facturas, setFacturas] = useState([]);

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  let est = 0.95;

  const obtenerFechaActualDefecto = () => {
    let fechaHoy = new Date();
    let anio = fechaHoy.getFullYear();
    let mes = fechaHoy.getMonth() + 1;

    if (mes < 10) {
      mes = "0" + mes;
    }

    return `${anio}-${mes}`;
  };

  useEffect(() => {
    setError(null);
    let consulta = "&fecha_inicio=201004&fecha_fin=202306&tipo=0";
    fetchFacturasEmitidas(consulta);
  }, [huerta]);

  const fetchFacturasEmitidas = async (consulta) => {
    try {
      const response = await avantSolarApi.get(
        `/facturacion/invoiceIssued?id_huerta=${huerta}` + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      if (data?.code == 200) {
        setFacturas([...data.data]);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();

    let fechaInicio = event.target.fechaInicio.value.replace("-", "");
    let fechaFin = event.target.fechaFin.value.replace("-", "");
    let tipo = event.target.tipo.value;
    let consulta = `&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&tipo=${tipo}`;
    fetchFacturasEmitidas(consulta);
  };

  let opciones = [
    { value: 0, label: "Normales" },
    { value: 1, label: "Mantenimiento" },
  ];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />

          <div className="p-1 w-100">
            <Row className="w-100">
              <form
                onSubmit={(event) => handleSubmitForm(event)}
                className="w-100 ml-5"
              >
                <Row className="w-100">
                  <Col
                    xs={12}
                    lg={6}
                    className="p-0 m-0 d-flex w-100 justify-content-end justify-content-center "
                  >
                    <div className="d-flex flex-column">
                      <span>Inicio:</span>
                      <input
                        className=""
                        name="fechaInicio"
                        defaultValue={"2010-04"}
                        type="month"
                      />
                    </div>
                    <div className="d-flex flex-column ml-2">
                      <span>Fin:</span>
                      <input
                        className=""
                        name="fechaFin"
                        defaultValue={obtenerFechaActualDefecto()}
                        type="month"
                      />
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    lg={6}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <span>Tipo:</span>
                    <Select
                      required
                      defaultValue={opciones[0]}
                      menuPlacement="top"
                      name="tipo"
                      options={opciones}
                      className="basic-multi-select w-50 ml-2"
                      classNamePrefix="select"
                    />

                    <button className="btn btn-primary ml-2">Enviar</button>
                  </Col>
                </Row>
              </form>
            </Row>
            <Table striped className=" tablaListado mt-3">
              <thead>
                <tr className="text-center">
                  <td>Id Factura</td>
                  <td>Instalacion</td>
                  <td>Concepto</td>
                  <td>Fecha</td>
                  <td>Estado</td>
                </tr>
              </thead>
              {!error && (
                <tbody>
                  {facturas?.map((factura) => {
                    return (
                      <tr className="text-center">
                        <td>{factura.id_factura}</td>
                        <td>Instalación {factura.instalacion}</td>
                        <td>{factura.concepto}</td>
                        <td>{convertirFecha(factura.fecha)}</td>
                        <td>{factura.estado}</td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </Table>
            {error && <Alert message={error} />}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ListadoInversores;
